import React, { Component, PropTypes as pt } from 'react';
import { FaCheck } from 'react-icons/lib/fa';

class Template extends Component {
    constructor (props) {
        super(props);

        this.assignTemplate = this.assignTemplate.bind(this);
    }
    assignTemplate () {
        if (!this.props.isSelected) {
            this.props.stateUtils.assignTemplate(this.props.index);
        }
    }

    render () {
        const { isSelected, template } = this.props;

        return (<div className={'template ' + (isSelected ? 'isSelected' : '')}>
            <div className="template-icon" onClick={this.assignTemplate}>
                <img alt={template.displayName}
                    className="img-responsive img-thumbnail"
                    src={template.icon}/>
            </div>
        </div>);
    }
}

Template.propTypes = {};

export default Template;
